//on inclue classiq
require("./vendor/davidmars/classiq/Classiq/_src/classiq.boot");
require("./vendor/davidmars/classiq/Classiq/_src/cq-debug/WebpackVersion");



//-------------------global utilities--------------------------

Pov.onBodyReady(function(){
    console.log("ready (app)");
    /**
     * La balise où notre histoire se passe
     * @type {JQuery}
     */
    window.$root=$("#root");
    /**
     * Le menu principal
     * @type {JQuery}
     */
    window.$nav=$("#nav");

    /**
     * La balise où sont chargées les pages (elle a aussi l'attribut [history-receiver])
     * @type {JQuery}
     */
    window.$main=$("#main");

    require("./fk.app/_src/FkMain");





    /**
     * Bon ça c'est notre vrai main
     * @type {FkMain}
     */
    window.FK=new FkMain();





});








// WEBPACK FOOTER //
// ./app.js